/**
 * When enabled, users can unsend messages
 */
export const ENABLE_UNSEND_MESSAGE_240913 = 'ENABLE_UNSEND_MESSAGE_240913';
